// import colors from '@rezdy/components/utils/colors';

export const blue = '#0046D1';
export const red = '#FA626F';
export const rowGap = '24px';
